import { render, staticRenderFns } from "./AssignLocation.vue?vue&type=template&id=01c4c7e4&"
import script from "./AssignLocation.vue?vue&type=script&lang=js&"
export * from "./AssignLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports